module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.article) ? _c('section', {
    staticClass: "sub-main take-place column actualities master-article"
  }, [_c('div', {
    staticClass: "cover column"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('img', {
    attrs: {
      "src": _vm.article.image,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content column"
  }, [_c('div', {
    staticClass: "tags row"
  }, _vm._l((_vm.article.news_tags), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "tag"
    }, [_vm._v("\n            " + _vm._s(_vm.resolveTag(tag)) + "\n\t\t\t\t\t")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.article.title)
    }
  }), _vm._v(" "), (_vm.article.author) ? _c('div', {
    staticClass: "author column"
  }, [_c('div', {
    staticClass: "ctn-profile-picture"
  }, [_c('img', {
    directives: [{
      name: "img-detect",
      rawName: "v-img-detect"
    }],
    attrs: {
      "src": _vm.article.author.image,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n\t\t\t\t\t\t\tRédigé par " + _vm._s(_vm.article.author.name) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t\t\tle " + _vm._s(_vm._f("moment")(_vm.article.updated_at, 'DD MMMM YYYY')) + "\n\t\t\t\t\t\t")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content-article"
  }, [_c('div', {
    staticClass: "item",
    domProps: {
      "innerHTML": _vm._s(_vm.article.body)
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5786398"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/article.vue
// module id = 1175
// module chunks = 0